export const BRAND = import.meta.env.VITE_BRAND ?? "aidocr"
export const APP_ENV = import.meta.env.VITE_APP_ENV ?? ""
export const IS_TAZ = BRAND === "taz" || (typeof APP_ENV === "string" && APP_ENV.startsWith("taz"))

/** Deep Think default for new sessions (on for TAZ, off for cloud). */
export const DEFAULT_USE_REASONING = IS_TAZ

/** Whether the Deep Think toggle is shown in chat and workflow UI. */
export const SHOW_DEEP_THINK_TOGGLE = !IS_TAZ

export const BRAND_NAME = IS_TAZ ? "Stadt Zurich" : "aidocr"

export const LOGO_SRC = IS_TAZ ? "/images/taz/logo_expanded.png" : "/aidocr-logo-sw.svg"
export const TAZ_LOGO_COLLAPSED_SRC = "/images/taz/logo_collapsed.svg"

export const TRANSLATION_LIMIT_MESSAGE_KEY = IS_TAZ
    ? "Your translation quota has been reached. This translation was not completed. Contact your administrator about additional capacity."
    : "Your translation quota has been reached. This translation was not completed. Review your plan options or contact sales at sales@aidocr.com."

export const TRANSLATION_LIMIT_DOWNLOAD_MESSAGE_KEY = IS_TAZ
    ? "Your translation quota has been reached. This translation was not completed. Contact your administrator about additional capacity."
    : "Your translation quota has been reached. This translation was not completed. Review your plan options."
